var app = angular.module('directives.bankDetails');

app.directive('bankDetails', [
    'configs',
    '$state',
    function (configs, $state) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/' + $state.current.name.replace('pages.', '') + '.html');//looking for template with moduleName
        } catch (e) {
            tmplUrl = require('../templates/index.html')//if error(no such file), use default template
        }

        return {
            template: tmplUrl,
            controller: 'bankDetailsCtrl',
            link: function (scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('bankDetailsCtrl', function ($scope, Pay, Counters, configs) {
    var tariffConfig = configs.payments_config;
    $scope.pay = Pay;
    $scope.counters = Counters;
    $scope.mUnit = Counters.mUnit;
    $scope.meterUnits = Counters.meterUnits;

});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/bankDetails/directives/bankDetails.js
 ** module id = 130
 ** module chunks = 1
 **/